export const ID_ELEMETS_WALKTHROUGH = {
  BUTTON_ASSESSMENT: 'button-assessment',
  BUTTON_BOOKS: 'button-books',
  BUTTON_CATALOGUE: 'button-catalogue',
  BUTTON_CLASSROOM: 'button-classroom',
  BUTTON_COMPETENCIES: 'button-competencies',
  BUTTON_CREATE_CLASSROOM: 'button-create-class',
  BUTTON_CREATE_TASK: 'create-task-button',
  BUTTON_HOME: 'button-home',
  BUTTON_TUTOR_IA: 'button-tutor-ia',
  CLASS_CODE_MODAL: 'expand-code-button',
}
